<template>
  <div id="app-wrapper">
    <transition name="fade-out">
      <app-overlay v-show="$loader.isLoading('App')"></app-overlay>
    </transition>
    <div class="view-wrapper">
      <div class="app-view">
        <!-- Mobile Navbar -->
        <app-navbar
          class="hide-for-desktop"
          ref="navbar"
          :applicationTitle="applicationTitle"
          @logout="logout"
          @navigation="navigation"
          v-if="$route.name != 'Login'"
        ></app-navbar>
        <div class="mainarea">
          <side-bar
            v-if="$route.name != 'Login'"
            v-show="$store.state.user"
            @logout="logout"
            @navigation="navigation"
          ></side-bar>
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppOverlay from "./components/AppOverlay";
import AppNavbar from "./components/AppNavbar";
import SideBar from "./components/SideBar";
import ApiService from "./services/api-service";
import UserService from "./services/user-service";
import router from "./router";

export default {
  name: "App",
  components: {
    AppOverlay,
    AppNavbar,
    SideBar
  },
  data() {
    return {
      applicationTitle: null
    };
  },
  created() {
    this.$bus.on("appl-title", this.setApplTitle);
    this.$bus.on("appl-title-remove", this.removeApplTitle);
  },
  methods: {
    navigation(target) {
      this.applicationTitle = null;
      router.push({ path: `/${target}` });
    },
    logout() {
      ApiService.logout(this);
      UserService.logout(this);
      localStorage.removeItem("stayLogged");
      this.$store.state.websocket.close();
      this.$store.state.websocketClosed = true;
      this.$emit("logout");
    },
    setApplTitle(title) {
      this.applicationTitle = title;
    },
    removeApplTitle() {
      this.applicationTitle = null;
    }
  }
};
</script>

<style>
#app-wrapper {
  height: 100%;
  overflow-x: hidden;
}
</style>
